<div class="card-title" [ngStyle]="{'font-size': getFontSize(), 'color': getFontColor()}">{{config.label}}</div>